import { useState } from 'react';
import { FAQS } from '../content';

export default function FAQ() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-bg py-20 md:py-28 border-t border-border">
      <div className="max-w-[760px] mx-auto px-6">
        <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-textp font-semibold">FAQ</h2>

        <div className="mt-10 divide-y divide-border border-y border-border" data-testid="faq-list">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-4 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className={`text-sm md:text-base font-medium transition-colors ${isOpen ? 'text-textp' : 'text-texts group-hover:text-textp'}`}>
                    {item.q}
                  </span>
                  <i
                    className={`ri-add-line text-texts text-lg transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`}
                  />
                </button>
                {isOpen && (
                  <div className="pb-5 pr-8">
                    <p className="text-sm text-texts leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
